import { Component, OnInit, OnDestroy } from '@angular/core';
import {Location} from '@angular/common';
import {Http, Headers, RequestOptions,Response} from '@angular/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {ShareService } from './../services/services';
import {Blog,BlogService } from './blog.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { Title } from '@angular/platform-browser';
import { AlertService} from './../services/alert.service';
import {Contact,ContactService } from './../contact/contact.service';
declare var jQuery: any;

interface PageData {
  title: string;
  description: string;
  meta_title: string;
  meta_description: string; 
  blog_title: string; 
  image: string; 
  image1: string; 
  image2: string; 
  price: string; 
  blog_description: string; 
  slug: string; 
  short_description:string;
  catslug:string;
       
}
let bigtos_pluugging = document.querySelector('bigtos');
let plugging = bigtos_pluugging ? bigtos_pluugging.innerHTML : "";

let componentmodel;

if(plugging.length)
{
    
   
    let jsonObject : any = JSON.parse(plugging)
    //console.log("hotel:->"+JSON.stringify(jsonObject));
    
    if(jsonObject.blog)
    {
	    componentmodel=true;
    }
    else
    {
	    componentmodel=false;
    }
}
//console.log("hoteldata"+hotemodel);
let componentdata;
if(componentmodel)
{
   componentdata={templateUrl: './pg/blog/detail.component.html'}
}
else
{
   componentdata={template: '<div></div>'}

   
}
@Component(componentdata)
/*
@Component({
	//template: require('./product.component.html')
	templateUrl: './pg/product/product.component.html',	
	
})*/
export class BlogComponent implements OnInit {
	
	public params;
	public apiData;
	pagedata: PageData;
	public serviceData;
	private _sub: Subscription;
	public metatitle;
    public metadescription;
    public singleproduct:Array<any>;
    InqueryForm: FormGroup;
    public currentslug;
	constructor(
	    private http: Http,
	    private _route: ActivatedRoute,
	    private _router: Router,
	    private shareService: ShareService,
	    private _title: Title,
	    private alertService: AlertService,
	    private _location:Location,
	    public fb: FormBuilder,  
	    private _contactService: ContactService,
	    private _pageService: BlogService) {
		   
		   this.pagedata = {
                  title:'',                  
                  description: '',
                  meta_title: '',
                  meta_description: '',
                  blog_title:'', 
				  image:'', 
				  image1:'',
				  image2:'', 
				  price:'', 
				  blog_description:'', 
				  short_description:'',
				  slug:'',
				  catslug:''
                 
				  	}
		   this.InqueryForm = fb.group({
      'email': [
        '', // default value
        Validators.compose([Validators.required, Validators.minLength(5)])
      ],
      'name': [
        '',
        Validators.compose([Validators.required, Validators.minLength(5)])
      ],
      
       'phone': [
        '',
        Validators.compose([Validators.required, Validators.minLength(5)])
      ], 
      'subject': [
        '',
        Validators.compose([Validators.required, Validators.minLength(5)])
      ],
   
      'message': [
        '',
        Validators.compose([Validators.required, Validators.minLength(5)])
      ]


    });			
				  	
				  	    
	    }
	    
     
	ngOnInit() {
	    // this.pagedata.description="umesh naga";
	       window.scrollTo(0, 0);
	        // console.log("Final testing");
	       
	  this._sub = this._route.params.subscribe(params => {
			let slug =params['slug'];
			this.currentslug=slug;
						
			   //this._applicationService.doLogin().subscribe	      
			   //this._pageService.getPage(slug);
			   			   
			   
			   this._pageService.getProduct(slug).subscribe(
        data => {
                 //                 
                  this.pagedata.title=data.menu.link_showing_name;
                   //console.log(slug);
                 // this.pagedata.description=data.data.menu.description;                 
                  if(data.blog.meta_title)
                  this._title.setTitle(data.blog.meta_title);
                  else
                  this._title.setTitle(data.blog.blog_title);                  
                  this.pagedata.blog_title=data.blog.blog_title;
                  this.pagedata.blog_description=data.blog.blog_description;
                  this.pagedata.image=data.blog.image;                  
                  this.pagedata.catslug=data.menu.slug;
                  
                   //let mainjs=this.shareService.getmainjs();
				   //jQuery.getScript('./'+mainjs);
                  ///alert(data.data.product.image1);
                  //$window.document.title ='someTitleYouCreated' ;              
           
        },
        err => console.error(err),
        () => console.log('blog completed')
    );
			   
			   
			   
			   
			   
			   		   
		});
		
	
		
	}

    ngOnDestroy() {
       this._sub.unsubscribe();
    }
    
     InqueryValidate(): boolean {

  if (this.InqueryForm.valid) {
    return true;
  }
  let errorMsg = '';

  let field_name = this.InqueryForm.controls['name'];
  if (!field_name.valid) {
    if (field_name.errors['required']) {
      errorMsg = 'Provide a Name please.<br />';
    }
  }

  let fieldemail = this.InqueryForm.controls['email'];
  if (!fieldemail.valid) {
    if (fieldemail.errors['required']) {
      errorMsg = errorMsg+'Provide a Email please.<br />';
    }
  }
 
  let fieldmesage = this.InqueryForm.controls['message'];
  if (!fieldmesage.valid) {
    if (fieldmesage.errors['required']) {
      errorMsg = errorMsg+'Provide a Message please.<br />';
    }
  }
 if(errorMsg!="")
 {
    //alert(errorMsg);
    this.alertService.error(errorMsg);
    
  return false;
  }
  else
  {
    return true;
  }
}
     
     doInquery(event) {
       
       
     if (this.InqueryValidate()) {
    
            let name = this.InqueryForm.controls['name'].value;
			let phone = this.InqueryForm.controls['phone'].value;
			let email = this.InqueryForm.controls['email'].value;
			//let subject ='Product Inquery';
			let slug =this.currentslug;
			let message = this.InqueryForm.controls['message'].value;
            this.params = {
                 
                  name: name,
                  email: email,
                  phone: phone,
                  slug:slug,
                  message:message,
                };
               this._pageService.doContactUs(this.params).subscribe(
        data => {
            this.apiData = data;
             //loading.dismiss();
             
             if(data.status=='success')
             {
	              this.alertService.success(data.message);
	              this.reset();
	              
             }
             else
             {
	             this.alertService.error(data.message);
             }
           
            
        },
        err => console.error(err),
        () => console.log('services completed')
    );
               console.log(this.InqueryForm.value);
               
               
               
              
    };
  }
    backClicked() {
    
        this._location.back();
    }
    
     reset() {
     this.InqueryForm.reset();
       }

}


// WEBPACK FOOTER //
// ./resources/assets/typescript/blog/blog.component.ts